import dayjs from "dayjs";

// The backend stamps UTC; the reader wants local time, in a table column too narrow for "AM/PM".
const localTime = (iso: string): dayjs.Dayjs | null => {
  const date = dayjs(iso.endsWith("Z") ? iso : `${iso}Z`);
  return date.isValid() ? date : null;
};

export const formatUtc = (iso: string): string => localTime(iso)?.format("DD.MM.YYYY HH:mm:ss") ?? iso;

export const formatUtcDate = (iso: string): string => localTime(iso)?.format("DD.MM.YYYY") ?? iso;

// Seconds included: an audit log has rows a few seconds apart, and they must not read as one moment.
export const formatUtcTime = (iso: string): string => localTime(iso)?.format("HH:mm:ss") ?? "";
